export const smRoutes = [

        { path:'sm/market-printcoupon-backendprint',name:'Sm-Market-Printcoupon-Backendprint',
            component: resolve => require(['@/views/sm/market/printcoupon/backendPrint/BackendPrint.vue'], resolve),props:true,
            meta:{compPath:'/sm/market/printcoupon/backendPrint/BackendPrint.vue'} 
        },
        { path:'sm/market-printcoupon-backendsend',name:'Sm-Market-Printcoupon-Backendend',
            component: resolve => require(['@/views/sm/market/printcoupon/backendSend/BackendSend.vue'], resolve),props:true,
            meta:{compPath:'/sm/market/printcoupon/backendSend/BackendSend.vue'} 
        },  
        
    ]
; 